import type { GreenlightRegistrationLookupResponse } from '../../../../api/historyCheck.typed';
import { typeSafeObjectKeys } from '@dist-marketplace-frontend/utils';

export const useMapVehicleDataToKeyInfo = (
  vehicleData: GreenlightRegistrationLookupResponse | null,
) => {
  const keyInfo = {
    vehicleMetaTitle: '',
    vehicleMetaList: [],
    currentReport: null,
    keyInfoListItems: [],
  };

  if (vehicleData?.vehicleDetails) {
    const vehicleDetails = vehicleData.vehicleDetails;

    const { Make = '-', Model = '-', Year = '-' } = vehicleDetails;
    const vehicleMetaTitle = `${Year} ${Make} ${Model}`;

    const vehicleMetaList = typeSafeObjectKeys(vehicleDetails).map((key) => ({
      displayName: key,
      value: vehicleDetails[key],
    }));

    const currentReport = vehicleData.availableReports[0] || null;

    const keyInfoListItems = [vehicleData.registration, vehicleDetails.Trim];

    return {
      vehicleMetaTitle,
      vehicleMetaList,
      currentReport,
      keyInfoListItems,
    };
  }

  return keyInfo;
};
